import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'rr0030',
    ecrans: ['00-2'],
    params: ['?demcleint', '?flgmod', "?efface_criteres"]
});
